import React, { useState } from "react";
import { FiSave, FiTrash2, FiXCircle, FiStar } from "react-icons/fi";
import { Formik, Field, Form } from "formik";
import { Featuring } from "../../pages/profiles/create/feature";
import { Skillset } from "../../pages/profiles/create/skillset";
import { Languages } from "../../pages/profiles/create/languages";
import { UploadImages } from "../image_upload";

export const UserEditDrawer = ({})=>{
    const [status, setStatus] = useState(true)
    const close = () => setStatus(false);
    const bodyTag = document.getElementsByTagName('html')[0];

    React.useEffect( () => {
        if(status)
            bodyTag.classList.add('stop')
        else
            bodyTag.classList.remove('stop') 
    },[status]);

    const options = [
        {name: 'Selected', value: '0'},
    ];

    const closeModal = (e) => {
        e.preventDefault()
        bodyTag.classList.remove('stop') 
        close();
    } 

     const drawerValues = {};
     const value = drawerValues || {};

    const formRef = React.useRef()
    const handleSubmit = () => {
        if (formRef.current) {
        //@ts-ignore
          formRef.current.handleSubmit()
        }
      }
    return status ? (
    <React.Fragment>
         
         <div className="user-edit-drawer">
                <title>User Edit Drawer</title>
                <div className="user-heading mb-3">
                    {!value?.mode && <div><h3>Create Profile</h3></div>}
                        {value?.mode && <div><h3>{value?.type}</h3></div>}
                    <div>
                        <a>
                            <FiTrash2 />
                        </a>
                        <a onClick={handleSubmit}>
                            <FiSave />
                        </a>
                        <a onClick={(e) => closeModal(e)}>
                            <FiXCircle />
                        </a>
                    </div>
                </div>

                <div className="scrollable">
                    <ProfileChanges 
                        newType={`user-edit-drawer`}
                        giveHand
                        type={value?.type}
                        formRef={formRef}
                    />
                </div>
                

                <div className="button-group" 
                >
                    <div className="row">
                        <div className="col-12">
                            
                            <div className="flex-end">
                                    <div className="mr-3">Reset</div>
                                    <button onClick={handleSubmit} type="submit" className="button primary float-right" >Apply</button>
                            </div>  
                        </div>
                    </div>
                </div>



            </div>
            <div
                className="overlay"
                onClick={(e) => closeModal(e)}
            >
        </div>

      
    </React.Fragment>

    ) : <React.Fragment></React.Fragment>
}

export default UserEditDrawer

const ProfileChanges = ({initialData, mode, type, bg, newType='user-edit', formRef, giveMeHand, giveHand})=>{
    let drawerValues = {}
     const value = drawerValues || {};


    const [initialProfile, setInitialProfile] = React.useState();

    React.useEffect(()=>{
   
    },[initialProfile])


    React.useEffect(()=>{
        getProfile(value.id);
    },[value.id])

    const getProfile = async (id) => {
        if(id){
        }
    }



    
    const options = [
        {name: 'Select', value: '0'},
    ];
 

    const openFeature = ({name,type}) => {} 
 
    
    const [images,setImages] = React.useState([])
    const [privacy,setPrivacy] = React.useState(false)


    return  (
    <div className="create-page bg-transparent m700">
     <Formik
     innerRef={formRef}
        initialValues={{ 
            type: type||options[0].value, 
        }}
        onSubmit={async (values, { setSubmitting, resetForm }) => { 
         
           
            // await resetForm();
            // TODO:// Print the server response
            setTimeout(() => {
                setSubmitting(false);
            }, 1000);

        }}
        >
        {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit,
            isSubmitting,
        }) => (
            <form onSubmit={handleSubmit}>
                <div className={`${bg?'profile-create':'nobg'}`}>
                    <div className="row">
                        <div className="col-6"> 
                            <label htmlFor="">Type {value?.mode ? 'Ok':'None'} </label>
                            {/**
                             <SelectSearch 
                                options={options} 
                                placeholder="Type" 
                                name="type"
                                aria-label="type"
                                label="type"
                                onChange={(val)=>{setFieldValue('type',val)}}
                                value={values.type}
                                // default={''}
                            />
                             */}
                        </div>
                    </div>

                    <ul>
                        <li className="flex">
                            <div className="profile_component">
                                {/* 
                                <ChooseComponent 
                                    type={newType} 
                                />
                                */}
                            </div>
                        </li> 
                            
                        
                    </ul>



                    <ul>
                        <li>
                            <div className="profile_component">
                                <div className="flex-end"><div className="flex" onClick={openFeature}> <p>Add Skill</p> <div className="open-button"> <FiStar /> </div> </div></div>
                                <Featuring data={[]} title="Educations" type={`${newType}-edu`} setFieldValue={setFieldValue} />
                                <div className="flex-end"><div className="flex" onClick={()=>openFeature({name:'Educational knowledge', type:`${newType}-edu`})}> <p>Add education</p> <div className="open-button"> <FiStar /> </div> </div></div>
                                <Featuring data={[]} title="Experiments" type={`${newType}-exp`} setFieldValue={setFieldValue} />
                                <div className="flex-end"><div className="flex" onClick={()=>openFeature({name:'Education', type:`${newType}-exp`})}> <p>Add experiment</p> <div className="open-button"> <FiStar /> </div> </div></div>
                            </div>
                        </li>
                    </ul>


                    <Skillset

                        type={newType}
                    />

                
                    <div className="profile_component">
                        <Languages type={newType} />
                    </div>


                    {!giveHand && (
                    <div className="">
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <button type="submit" className="button primary float-right" >Update</button>
                                </div>    
                            </div>
                        </div>
                    </div>
                    )}


                <div className="profile-create mt-3">
                    <UploadImages
                        images={images}
                        setImages={setImages}
                    />
                </div>
                {/** 
                

                    */}
                </div>

            </form>
            )}
        </Formik>
      
    </div>

    )
}  

